import React from 'react';
import NinjaTable from 'components/tables/NinjaTable';
import ValueFormatter from 'components/table-formatters/values/ValueFormatter';
import AdsetStatusTableFormatter from 'modules/adsets/table-formatters/AdsetStatusTableFormatter';
import { JustValueFormatter } from 'components/tables/NinjaTable/formatters';
import {
  RoiFormatter,
  RoasFormatter,
  SpentFormatter,
} from 'components/tables/NinjaTable/formatters';
import { AdsetFormatter } from 'components/tables/NinjaTable/formatters/sourceFormatters';

const list = [
  {
    name: 'Name',
    key: 'adset',
    resizable: true,
    sortable: true,
    maxWidth: 250,
    minWidth: 250,
    renderCell: ({ row }) => <AdsetFormatter editStatus={true} row={row} />,
    renderSummaryCell: () => 'Totals',
  },
  {
    name: 'Ads',
    key: 'adset.ads_count',
    sortable: true,
    renderCell: ValueFormatter,
  },
  {
    name: 'Ad Spent',
    key: 'ad_spent',
    sortable: true,
    renderCell: JustValueFormatter,
    renderSummaryCell: (data) => {
      return <SpentFormatter row={data.row} />;
    },
  },
  {
    name: 'Impressions',
    key: 'impressions',
    sortable: true,
    renderCell: ValueFormatter,
    renderSummaryCell: ValueFormatter,
  },
  {
    name: 'Clicks',
    key: 'clicks',
    sortable: true,
    renderCell: ValueFormatter,
    renderSummaryCell: ValueFormatter,
  },
  {
    key: 'roi',
    name: 'ROI',
    sortable: true,
    renderCell: RoiFormatter,
    renderSummaryCell: RoiFormatter,
  },
  {
    key: 'roas',
    name: 'ROAS',
    sortable: true,
    renderCell: RoasFormatter,
    renderSummaryCell: RoasFormatter,
  },
  {
    name: 'CPA',
    key: 'cpa',
    sortable: true,
    renderCell: JustValueFormatter,
    renderSummaryCell: JustValueFormatter,
  },
  {
    name: 'CPC',
    key: 'cpc',
    sortable: true,
    renderSummaryCell: JustValueFormatter,
  },
];

const AdsetsTable = (props) => {
  return (
    <NinjaTable
      cardProps={{ disable: true }}
      title='Adsets'
      dataProvider='adsetsList'
      columns={list}
      sortableColumns
      {...props}
    />
  );
};

export default AdsetsTable;
